import { FC } from "react";
import { Heading, Stack, VStack, Text } from "@chakra-ui/react";

import { PrismicLink } from "src/atoms";

const DesktopStack: FC<{
  linksGroups: Gatsby.SiteFooterDataBodyLinksGroupFragment[];
}> = ({ linksGroups }) => {
  return (
    <Stack
      direction="row"
      align="flex-start"
      spacing="0"
      w="full"
      display={{ base: "none", md: "flex" }}
    >
      <Stack
        direction="row"
        spacing={{ base: "space-40", xl: "space-80" }}
        w="full"
      >
        {linksGroups.map((group) => {
          if (!group) return null;
          return (
            <VStack
              key={group.primary?.title}
              flex={1}
              textAlign="left"
              align="flex-start"
              spacing="space-16"
            >
              <Text
                as="h3"
                key={group.primary?.title}
                marginBottom="space-16"
                variant="body-xl"
                color="white"
              >
                {group.primary?.title}
              </Text>



              {group.items?.map((item) => {
                if (!item?.link) return null;

                return (
                  <PrismicLink
                    link={item.link}
                    key={item.link_label}
                    fontSize="font-15"
                    lineHeight="base"
                    color="white"
                    letterSpacing={"semitight"}
                  >
                    {item.link_label}
                  </PrismicLink>
                );
              })}
            </VStack>
          );
        })}
      </Stack>
    </Stack>
  );
};

export default DesktopStack;
